import { Stack, Typography } from '@mui/material';
import { RecentChip } from './EquipmentOptionStyled';
import AlertIcons from './AlertIcons';
import HighlightText from 'components/UI/Inputs/AIQAutocomplete/HighlightText';
import PropTypes from 'prop-types';

const Header = ({ headerName, optionRef, alerts, isRecent = false, searchTerm }) => (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1}>
            <Typography ref={optionRef} fontSize={14} fontWeight={600}>
                <HighlightText text={headerName} searchTerm={searchTerm} />
            </Typography>
            {isRecent && <RecentChip label="Recent" size="small" />}
        </Stack>
        {alerts && <AlertIcons alerts={alerts} />}
    </Stack>
);

Header.propTypes = {
    headerName: PropTypes.string,
    optionRef: PropTypes.object,
    alerts: PropTypes.array,
    isRecent: PropTypes.bool,
    searchTerm: PropTypes.string,
};

export default Header;
